import { ApiRateLimitStat } from '@tribeplatform/gql-client/types'

import { useQuery, UseQueryOptions } from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getRateLimitStatsKey } from '../../utils/keys/api-stats.key.js'

export const useApiRateLimitStats = (options?: {
  useQueryOptions?: UseQueryOptions<ApiRateLimitStat[]>
}) => {
  const { useQueryOptions } = options || {}
  const { client } = useTribeClient()

  return useQuery<ApiRateLimitStat[]>(
    getRateLimitStatsKey(),
    () => client.network.apiRateLimitStats(),
    useQueryOptions,
  )
}
